import React, {useCallback} from 'react';
import {usePlaidLink} from 'react-plaid-link';
import axios from "axios";
import {Button} from 'semantic-ui-react'

const PlaidMicroDeposits = ({accountId, plaidEnviroment, bankAccountData, setPlaidData, hideAccount, updateStatus, tooManyVerificationAttemptsCallback}) => {

    const onSuccess = useCallback(async(_, data) => {
        const {account_id, public_token} = data
        const status = data.account?.verification_status
        const metadata = {"verificationStatus": status, "verifiedAt": (new Date()).toISOString()}
        await updateStatus({account_id, status, public_token})
        await setPlaidData({...data, metadata})
        hideAccount(account_id)
    }, [setPlaidData, hideAccount, updateStatus])

    const onExit = useCallback(async (error, metadata) => {
        if(!error) {
            return
        }
        if(error.error_code === 'TOO_MANY_VERIFICATION_ATTEMPTS'){
                const status = "verification_failed"
                updateStatus({account_id: accountId, status})
                tooManyVerificationAttemptsCallback(accountId)
        }
        console.log({error, metadata})
        try {
            await axios.post("/api/member/v2/plaidError", {error, metadata}, {headers: {'Content-Type': 'application/json'}});
        } catch (e) {
            console.warn(e)
        }
    }, [accountId, tooManyVerificationAttemptsCallback, updateStatus]);

    const config = {
        token: bankAccountData.plaidLinkToken,
        env: plaidEnviroment,
        onSuccess,
        onExit,
    }

    const {open, ready, loading} = usePlaidLink(config)

        return(<>
            <Button className="link" disabled={!ready || loading} onClick={open} basic primary>
                Verify account
            </Button>
        </>)
}

export default PlaidMicroDeposits